export const iconFontAwesomeArrowsCircleRight = (
	<i className="fa-solid fa-circle-right"></i>
);
